import { Check, Copy, Users } from 'lucide-react'
import { useState } from 'react'
import { SettingsRow } from './SettingsRow.tsx'
import styles from './InviteCode.module.css'

type Props = { householdName: string | null; code: string }

// Surfaces a household's join code so a member can share it with their own
// family. The subtext is the only place we explain what the code is for.
export const InviteCode = ({ householdName, code }: Props) => {
	const [copied, setCopied] = useState(false)

	const copy = async () => {
		try {
			await navigator.clipboard.writeText(code)
			setCopied(true)
			window.setTimeout(() => setCopied(false), 1500)
		} catch {
			// clipboard blocked — the code is on screen anyway
		}
	}

	return (
		<SettingsRow
			icon={<Users size={18} />}
			label="Family code"
			value={<span className={styles.code}>{code}</span>}
			action={
				<button type="button" onClick={copy}>
					{copied ? (
						<>
							<Check size={15} aria-hidden /> Copied
						</>
					) : (
						<>
							<Copy size={15} aria-hidden /> Copy
						</>
					)}
				</button>
			}
			hint={
				<>
					Share this with your family so they can join{' '}
					{householdName ?? 'your household'} — they enter it when
					they first sign in, and you'll all see the same lists.
				</>
			}
		/>
	)
}
